export default "__VITE_ASSET__CJwc8Eqk__"